import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/components/style/common.scss';
import Axios from "axios";
import store from './store'

const env = process.env.NODE_ENV === 'development' ? 'development' :
  process.env.VUE_APP_TITLE === 'test' ? 'test' : 'production';
const urls ={
  sendMessage:""
};

if(env === "development"){
  urls.sendMessage = "/pttool/v1/sms/send/code";
  urls.uc = "https://apitest.xianlaigame.com";
  urls.oauth = "/oauth/v1/user/identitynumber";
  urls.check = "/oauth/user/bind/tel/verify";
  urls.ams = 'https://apitest.xianlaigame.com/ams/v1/user/asset/';
  urls.ganmeInfo = 'https://apimalltest.xianlaigame.com/co/v1/wechat/gameInfo';
  urls.gamesKey = {
    "chuanqi":"XL_bcad403c0ae96ef6e0e971ff1c2b2a14",
    "buyu":"xl8fb498b1961375ce",
    "rexue":"xl23c2182418d6f75b",
    "xiyou":"xlc70394a9c66a59d1"
  }
}else{
  urls.sendMessage = "/pttool/v1/sms/send/code";
  urls.uc = "https://api.ixianlai.com";
  urls.oauth = "/oauth/v1/user/identitynumber";
  urls.check = "/oauth/user/bind/tel/verify";
  urls.ams = 'https://api.ixianlai.com/ams/v1/user/asset/';
  urls.ganmeInfo = 'https://api.ixianlai.com/co/v1/wechat/gameInfo';
  urls.gamesKey = {
    "chuanqi":"xlbef0baa7edf72cd4",
    "buyu":"xl721a70c2f34b9561",
    "rexue":"xl738d19ca24bf0a91",
    "xiyou":"xl1fa0323efa2243f0"
  };
 //TODO:线上环境删除以下代码
  urls.sendMessage = "/pttool/v1/sms/send/code";
  urls.uc = "https://apitest.xianlaigame.com";
  urls.oauth = "/oauth/v1/user/identitynumber";
  urls.check = "/oauth/user/bind/tel/verify";
  urls.ams = 'https://apitest.xianlaigame.com/ams/v1/user/asset/';
  urls.ganmeInfo = 'https://apimalltest.xianlaigame.com/co/v1/wechat/gameInfo';
  urls.gamesKey = {
    "chuanqi":"XL_bcad403c0ae96ef6e0e971ff1c2b2a14",
    "buyu":"xl8fb498b1961375ce",
    "rexue":"xl23c2182418d6f75b",
    "xiyou":"xlc70394a9c66a59d1"
  }
}
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$axios = Axios;
Vue.prototype.$ajaxUrls = urls;

let lastLogTime = window.sessionStorage.getItem('loginTime');
let nowTime = new Date().getTime();
if(lastLogTime !== null && lastLogTime !== undefined && lastLogTime !== ""){
  if((nowTime - lastLogTime)<14400000){
    store.state.haslogin = true;
    store.state.userData = JSON.parse(window.sessionStorage.getItem("userData"));
    store.state.asset = JSON.parse(window.sessionStorage.getItem("asset"));
    Vue.prototype.$ajaxUrls.appKey =window.sessionStorage.getItem("appKey");
  }else{
    router.push({name:"home"})
  }
}
router.afterEach((to, from) => {
  document.documentElement.scrollTop = 0;
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
